import React from "react";

import { LoadingPage } from "../../components/LoadingPage";
import { GoogleAuthConsumer } from "./GoogleAuthContext";
import { GoogleUserProvider } from "./GoogleUserContext";

/**
 * Shows a spinner until Google Auth has initalized.
 */
export class GoogleAuthInitalizer extends React.Component {
    render() {
        return (
            <GoogleAuthConsumer>
                {auth => (
                    !auth
                        ? <LoadingPage />
                        : (
                            <GoogleUserProvider>
                                {this.props.children}
                            </GoogleUserProvider>
                        )
                )}
            </GoogleAuthConsumer>
        );
    }
}
